import React from 'react';
import './ImageStyleSheet.css';

function BU1() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/bu1.jpeg" className='img-view'/>
        </div>
    )
}

export default BU1
